import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import DispatchOrdersList from './list';
import DispatchOrdersAddEdit from './edit';
import DispatchOrdersAprovals from './approvals';

export const dispatchOrdersRoutes = [
  {'component': <DispatchOrdersList />, 'path': paths.DispatchOrdersList},
  {'component': <DispatchOrdersAddEdit />, 'path': paths.DispatchOrdersAdd},
  {'component': <DispatchOrdersAddEdit />, 'path': paths.DispatchOrdersEdit},
  {'component': <DispatchOrdersAprovals />, 'path': paths.DispatchOrdersApprovals},
];

